module.exports = __webpack_public_path__ + "img/Glaxosmith.afbc81a3.jpg";